import { Badge, Box, Group, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const NameCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Group gap={'xs'}>
                    <NavLink to={`/resources/agents/${rowData.id}`}>
                        <Text>{rowData.name}</Text>
                    </NavLink>
                    {rowData.subName ? (
                        <Badge
                            color={'blue'}
                            size={'xs'}>
                            {rowData.subName}
                        </Badge>
                    ) : null}
                </Group>
                <Text>{rowData.hub || 'default-hub'}</Text>
            </Stack>
        </Box>
    );
};

const NameColumn = () => ({
    accessorKey: 'name',
    header: 'Name / Hub',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <NameCell cell={cell} />,
});
export default NameColumn;
